import React from "react";

export default function DefinitionDisplay(props) {
    
    return (
        <div className="text-left text-sm font-normal mx-auto my-2 md:w-full bg-city-green-light/70 rounded-md p-2">
            <ul>
                <li><span className="font-bold">Land:</span> The market value of your land if no improvements existed.</li>
                <li><span className="font-bold">Improvements:</span> The value of all real property investments, including buildings, grading, and paving.</li>
                <li><span className="font-bold">True Cash Value:</span> The appraised market value of your property.</li>
                <li><span className="font-bold">Assessed Value:</span> 50% of the value of your property.</li>
                <li><span className="font-bold">Taxable Value:</span> Taxes owed are based on the Taxable Value, which is set at assessed value in the year of purchase but annual increases are capped at the lower of inflation or 5%.</li>
                <li><span className="font-bold">Millage Rate:</span> Each local government charge mills to your property. Each mill charges $1 of taxes per $1000 of taxable value. Taxes are levied on either the Summer or Winter tax bill.</li>
                <li><span className="font-bold">Exemption:</span> A proposed 14 mill reduction is set by the local government.</li>
                <li><span className="font-bold">LVT Millage Rate:</span> LVT millage rate is set to replace the exempted 14 mills.</li>
            </ul>
        </div>
    )
}